import { onDocumentReady } from '../utils/events';
import Splide from '@splidejs/splide';
import { AdjustableHeight } from '../utils/splide-auto-height';
import { loadLazyElements, updateLazyLoad } from './lazyload';

onDocumentReady(() => {
  const sliderEl = document.querySelector('.case-studies__items');

  if (sliderEl) {
    const splide = new Splide(sliderEl, {
      type: 'loop',
      perMove: 1,
      perPage: 3,
      gap: '1.875rem',
      drag: true,
      flickPower: 150,
      dragMinThreshold: {
        mouse: 40,
        touch: 70,
      },
      arrows: true,
      pagination: true,
      keyboard: 'focused',
      rewind: true,
      focus: 0,
      breakpoints: {
        1200: {
          perPage: 2,
        },
        1024: {
          gap: '1.25rem',
        },
        768: {
          perPage: 1,
        },
        640: {
          pagination: false,
        },
      },
    });

    const loadVisibleSlideImages = () => {
      updateLazyLoad();

      const slides = sliderEl.querySelectorAll(
        '.splide__slide.is-active, .splide__slide.is-visible, .splide__slide.is-prev, .splide__slide.is-next'
      );
      const images = [];

      slides.forEach((slide) => {
        images.push(...slide.querySelectorAll('img[data-lazy-src]'));
      });

      loadLazyElements(images);
    };

    splide.on('mounted move moved resized updated', () => {
      window.requestAnimationFrame(loadVisibleSlideImages);
    });

    splide.mount({ AdjustableHeight });
  }
});
